export enum TipoColaboradorEnum {
    FUNCIONARIO = 0,
    CONTRIBUINTE = 1,
    ESTAGIARIO = 2
}
